import client from './apiClient';

const getSubscriptionInfo = () => client.get('/subscription/info');
const postSubscriptionInfo = (data) => client.post('/subscription/info', JSON.stringify(data));
const putSubscriptionInfo = (id, data) => client.put(`/subscription/info?subscriptionId=${id}`, JSON.stringify(data));
const deleteSubscriptionInfo = (id) => client.delete(`/subscription/info?subscriptionId=${id}`);

const getSubscriptionPlans = (params = {}) => {
  const query = new URLSearchParams({
    ...(params.planCategory && { planCategory: params.planCategory }),
    ...(params.scope && { scope: params.scope }),
    ...(params.search && { search: params.search }),
    page: params.page || 1,
    pageSize: params.pageSize || 10,
    ...(params.includeInactive && { includeInactive: true }),
  }).toString();

  return client.get(`/subscription/plan?${query}`);
};
const getSubscriptionPlanById = (planId, source, includeInactive = false) => {
  const params = source === 'B2B_TEMPLATE'
    ? `templateId=${planId}`
    : `subscriptionPlanId=${planId}`;
  return client.get(`/subscription/plan?${params}${includeInactive ? '&includeInactive=true' : ''}`);

};
const resolvePlanParam = (planType) => {
  if (planType === 'assessment' || planType === 'b2b') return 'assessment';
  return 'course';
};

const postSubscriptionPlan = (subscriptionId, data, planType) =>
  client.post(
    `/subscription/plan?subscriptionId=${subscriptionId}&isAssessment=${resolvePlanParam(planType)}`,
    data
  );

const putSubscriptionPlan = (planId, data, planType) =>
  client.put(
    `/subscription/plan?subscriptionPlanId=${planId}&isAssessment=${resolvePlanParam(planType)}`,
    data
  );
const putSubscriptionPlanStatus = (planId, data, planType) => client.put(`/subscription/planstatus?subscriptionPlanId=${planId}&isAssessment=${resolvePlanParam(planType)}`,data);

  const SubscriptionPlanLive = (planId, planType,tier, isB2B = false) =>
  client.put(
    `/subscription/plan/live?subscriptionPlanId=${planId}&isAssessment=${resolvePlanParam(planType)}&tier=${tier}&isB2B=${isB2B}`
  );
const postB2BTemplatePlan = (data) => client.post(`/subscription/b2b-template-plan`, data);
const putB2BTemplatePlan = (templateId, data) => client.put(`/subscription/b2b-template-plan?id=${templateId}`, data);
const deleteB2BTemplatePlan = (templateId) => client.delete(`/subscription/b2b-template-plan?id=${templateId}`);

const deleteSubscriptionPlans = (id) => client.delete(`/subscription/plan?subscriptionPlanId=${id}`);

const getSubscriptionDetailsByPlanId = (planId, userId) =>
  client.get(`/individual/user/subscription/course?subscriptionPlanId=${planId}&userId=${userId}`);

const getSubscribersByPlanId = (planId, page = 0, pageSize = 10, { source } = {}) => client.get(`/subscription/client?planId=${planId}&subscriptionId=${planId}&page=${page}&pageSize=${pageSize}&source=${source}`);
const getAssessmentplandetails = () => client.get(`/subscription/getassessmentplandetails`);


export default {
  putSubscriptionPlanStatus,
  SubscriptionPlanLive,
  getSubscriptionInfo,
  deleteSubscriptionInfo,
  putSubscriptionInfo,
  getSubscriptionPlans,
   getSubscriptionPlanById,
  postSubscriptionInfo,
  postSubscriptionPlan,
  deleteSubscriptionPlans,
  putSubscriptionPlan,
  postB2BTemplatePlan,
  putB2BTemplatePlan,
  deleteB2BTemplatePlan,
  getSubscriptionDetailsByPlanId,
  getSubscribersByPlanId,
  getAssessmentplandetails
};